var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVasQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9648_36006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 5.05127C14.0938 5.05127 15 5.95752 15 7.05127V9.05127H17C17.5312 9.05127 18 9.52002 18 10.0513C18 10.6138 17.5312 11.0513 17 11.0513H15V13.0513C15 14.1763 14.0938 15.0513 13 15.0513H12C10.875 15.0513 10 14.1763 10 13.0513V7.05127C10 5.95752 10.875 5.05127 12 5.05127H13ZM13 7.05127H12V13.0513H13V7.05127ZM3 9.05127H9V11.0513H3C2.4375 11.0513 2 10.6138 2 10.0513C2 9.52002 2.4375 9.05127 3 9.05127Z",
    fill: "#7F99A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9648_36006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2.05127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVasQuestion);
export default __webpack_public_path__ + "static/media/vas-question.5552fcc13d897422b6dd979368c77e87.svg";
export { ForwardRef as ReactComponent };